import { render } from "./TemplateModalPoi.vue?vue&type=template&id=6e263ea8&scoped=true&ts=true"
import script from "./TemplateModalPoi.vue?vue&type=script&lang=ts"
export * from "./TemplateModalPoi.vue?vue&type=script&lang=ts"

import "./TemplateModalPoi.vue?vue&type=style&index=0&id=6e263ea8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e263ea8"]])

export default __exports__